import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "../components/ui/button";

export default function PaymentCancel() {
  return (
    <div className="container-x py-24 text-center max-w-xl" data-testid="payment-cancel-page">
      <XCircle size={56} className="text-destructive mx-auto mb-6" />
      <h1 className="text-4xl font-light mb-3">Paiement annulé</h1>
      <p className="text-muted-foreground mb-8">Votre réservation reste enregistrée et peut être payée sur place ou ressayée.</p>
      <Button asChild className="bg-[#2B8B8E] hover:bg-[#1F6F73] text-white rounded-full px-8">
        <Link to="/mon-compte">Mon compte</Link>
      </Button>
    </div>
  );
}
